__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/6e7f30c2ba84efa2a8394ec6f8b73449fe219347/_next/";